import React, { useState, useEffect } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import "../../css/main.css"

import { useAPICall } from '../../hooks/useAPICall.js';
import { useNavigate } from 'react-router-dom';
import { PageMenuElement } from '../elements/page_menu.js';

export function AdminPosUploadForm() {
  
  const navigate = useNavigate();

  const [pageData, setPageData] = useState([]);
  const [memberData, setMemberData] = useState([]);
  const [receiptData, setReceiptData] = useState([]);

  const [customerName, setCustomerName] = useState('');
  const { MakeCall } = useAPICall();


  function handleNav(destination, state) {
    navigate(destination, state);
  }

  


  function handleDataFetch(data) {
    setPageData(data);
    setReceiptData(data.components['receipts']);
    
  }

  function handlePosUpload(data) {
    MakeCall('pos/getposupload', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch, true);
  }


  function handleReProcess()
  {
    MakeCall('pos/reprocess', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handlePosUpload, true);
  }
  
    function onPageMenuClick(onclickname) {
      switch (onclickname) {
        case 'goback':
                  handleNav("/Admin");
                  break;
        case 'process_unallocated':
            handleReProcess();
            break;     
            default:
                break;
    }
    }

  function handleFileUpload() {
    var filesSelected = document.getElementById("inputFileToLoad").files;
    if (filesSelected.length > 0) {
      var fileToLoad = filesSelected[0];

      var fileReader = new FileReader();

      fileReader.onload = function (fileLoadedEvent) {
        var srcData = fileLoadedEvent.target.result; // <--- data: base64

        const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
          "\"file_name\" : \"" + fileToLoad + "\", " +
          "\"file_data\":\"" + srcData + "\"}";

        MakeCall('pos/adminuploadpos', postBody, handlePosUpload, true);
      }
      fileReader.readAsDataURL(fileToLoad);
    }
  }

  useEffect(() => {
    MakeCall('pos/getposupload', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
    
  });

  function handleAddPseudonym(customer) {
    setCustomerName(customer);
    if (document.getElementById('addpseudonym')) {
      document.getElementById('addpseudonym').style.display = "block";
    }
    
  }

  function handleMemberSeachComplete(data)
  {
    setMemberData(data.components['members'].member_list);
  }
  function handleSearchMembers()
  {
    let search_phrase = document.getElementById('search_phrase').value;
    sessionStorage.setItem("search_phrase", search_phrase);


    MakeCall('admin/getmembersearchbyname', "{ \"token\" : \"" + sessionStorage.getItem("Token") +
        "\", \"search_phrase\" : \"" + search_phrase +
        "\", \"page\":\"1" +
        "\", \"membership_type\":\"0"+
        "\", \"membership_status\":\"0"+
        "\", \"result_limit\":\"5"+
        "\"}", handleMemberSeachComplete, true);
  }
function handlePseudonymAdded(data)
{
  if (document.getElementById('addpseudonym')) {
    document.getElementById('addpseudonym').style.display = "none";
  }
}
  function handleUpdatePseudonym(idpeveril_member)
  {
    MakeCall('member/addpseudonym', "{ \"token\" : \"" + sessionStorage.getItem("Token") +
        "\", \"customer\" : \"" + customerName +
        "\", \"idpeveril_member\":\"" + idpeveril_member + "\"}", handlePseudonymAdded, true);
  }
  function ShowAddPseudonym() {
    return (
      <div className='popup_form' id="addpseudonym" >
        <h1>Add Pseudonym</h1>
        <p>You can add this customer name to an existing member. When the Unalloacted receipts are reprocessed, those with this customer name will be alloacted to the member you choose.
          This is necassary when the POS system customer name does not exactly match the membership database name.
        </p>
        <div className='formrow' style={{ "paddingBottom": "1em" }}>
          <div className='formlabel' style={{ "width": "30%" }}>
            POS Customer Name
          </div>
          <div className='formvalue'>
            {customerName}
          </div>
        </div>
        <div className='formrow'>
          <div className='formlabel' >
            Search Member
          </div>
          <div className='formvalue'>
            <input type="text" id="search_phrase" className='logininput'/>            
          </div>
          <div className='formvalue'>
            <button className='logininput' style={{ "width": "85px" }} onClick={handleSearchMembers}>Search</button>
          </div>
        </div>
        <div style={{"height": "1em"}}></div>
        <div className='formbox'>
          <div className='formtitle'>Members</div>
          <div className='gridrow'>
            <div className='gridcolumn' style={{ "width": "33%" }}>Member No</div>
            <div className='gridcolumn' style={{ "width": "33%" }}>Member Name</div>
            <div className='gridcolumn' style={{ "width": "33%" }}></div>
          </div>
          { memberData.map((member) => (
            <div key={member.idpeveril_member} className='gridrow'>
              <div className='gridcell' style={{ "width": "33%" }}>{member.membership_number}</div>
              <div className='gridcell' style={{ "width": "33%" }}>{member.forename + ' ' + member.surname}</div>              
              <div className='gridcell' style={{ "width": "33%" }}><button type='button' className='logininput' onClick={() => { handleUpdatePseudonym(member.idpeveril_member) }}>Add Pseudonym</button></div>
            </div>
          ))}
        </div>
        
           <div style={{"height": "1em"}}></div>
          <div className='formrowcentered'><button className='logininput' style={{ "width": "200px" }} onClick={() => {document.getElementById('addpseudonym').style.display = "none"}}>Close</button></div>
        
      </div>);
  }

  return (
    <div>

      {SecurityElement(pageData)}
      {MenuForm()}
      {ShowAddPseudonym()}
      <div className="contentdiv">
        {PageMenuElement("Upload POS File", [{ "name": "Back", "onclick": "goback" },
                                              { "name": "Re-process unallocated", "onclick": "process_unallocated" }], onPageMenuClick)}



        <div className='formbox'>
          <div className='formtitle'>Upload POS File</div>
          <div className='formrow'>

          </div>

          <div className='formrow'>

            <input type='file' className='loginfileinput' id='inputFileToLoad' />
          </div>
          <div className='formrowcentered'>
            <input type='button' className='prcbtn' value='Upload' onClick={handleFileUpload} />
          </div>

        </div>
        <div className='formbox'>
          <div className='formtitle'>Unalloacted Receipts</div>
          <div className='gridrow' key={"header"} >
            <div className='gridcolumn' style={{ "width": "25%" }}>Date</div>
            <div className='gridcolumn' style={{ "width": "25%" }}>Customer</div>
            <div className='gridcolumn' style={{ "width": "25%" }}>Type</div>
            <div className='gridcolumn' style={{ "width": "25%" }}></div>
          </div>
          {receiptData.map((receipt) => (
            <div key={receipt.idpeveril_pos_upload} className='gridrow'>
              <div className='gridcell' style={{ "width": "25%" }}>{receipt.receipt_date}</div>
              <div className='gridcell' style={{ "width": "25%" }}>{receipt.customer}</div>
              <div className='gridcell' style={{ "width": "25%" }}>{receipt.receipt_description}</div>
              <div className='gridcell' style={{ "width": "25%" }}><button type='button' className='logininput' onClick={() => { handleAddPseudonym(receipt.customer) }}>Add Pseudonym</button></div>
            </div>
          ))}
        </div>
        <div>
        </div>
      </div>
    </div>
  );
}
